import { render, staticRenderFns } from "./AttachmentCarosel.vue?vue&type=template&id=09566caa&scoped=true"
import script from "./AttachmentCarosel.vue?vue&type=script&lang=js"
export * from "./AttachmentCarosel.vue?vue&type=script&lang=js"
import style0 from "./AttachmentCarosel.vue?vue&type=style&index=0&id=09566caa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09566caa",
  null
  
)

export default component.exports